export const PRE_PROD_REGEX = /dashboard-pre-prod\.prod\.branch\.io/;

export class EnvironmentDetector {
  detect() {
    const custom = localStorage.getItem('force_env_name');
    const url = new URL(window.location.href);
    const local = url.hostname === 'localhost';
    const stage = url.hostname.endsWith('.stage.branch.io');
    const oldBeta = url.hostname.endsWith('.beta.branch.io');
    const newBeta = stage && url.hostname.split('.')[0].startsWith('dashboard-');
    const preProd = EnvironmentDetector.isPreProd(url.hostname);
    const checksum = this.isChecksum(url.hostname);

    if (custom) {
      return custom;
    }

    if (local) {
      return null;
    }

    if (preProd) {
      return 'dashboard-pre-prod';
    }

    if (oldBeta) {
      return url.hostname.split('.')[0];
    }

    if (newBeta) {
      return url.hostname.split('.')[0].replace(/^dashboard-/, '');
    }

    if (stage || checksum) {
      return 'stage';
    }

    return 'production';
  }

  public static isPreProd(url: string): boolean {
    return PRE_PROD_REGEX.test(url);
  }

  private isChecksum(hostname: string): boolean {
    return hostname === 'd3t0vyzb3ndf7j.cloudfront.net';
  }
}
